import Vue from 'vue';
import VueSlider from 'vue-slider-component';

Vue.component('VueSlider', VueSlider);
